import React from 'react';
import { Form } from 'react-bootstrap';
import { useCampaign } from '../CampaignContext';

const Step1Title = () => {
    const { state, dispatch } = useCampaign();
    const { title } = state;

    const handleTitleChange = (e) => {
        dispatch({ type: 'UPDATE_TITLE', payload: e.target.value });
    };

    return (
        <div className="py-2">
            <h5 className="font-weight-bold mb-3">Define Campaign Title</h5>
            <p className="text-muted small mb-4">
                This name is for internal reference only and will not be visible to recipients.
            </p>
            
            <Form.Group className="mb-4">
                <Form.Label className="font-weight-bold small text-muted">CAMPAIGN NAME</Form.Label>
                <Form.Control 
                    type="text" 
                    placeholder="Enter campaign title e.g., March Mid-Term Reminder" 
                    className="wcm-input-lg font-weight-bold"
                    value={title}
                    onChange={handleTitleChange}
                    isInvalid={title.length > 50}
                />
                <Form.Control.Feedback type="invalid">
                    Title must be less than 50 characters.
                </Form.Control.Feedback>
                <Form.Text className="text-muted">
                    {title.length}/50 characters used.
                </Form.Text>
            </Form.Group>

            <div className="p-3 bg-light rounded mt-5 border">
                <p className="small m-0 text-muted">
                    <i className="fas fa-info-circle mr-2 text-primary" />
                    <strong>Tip:</strong> Use clear, descriptive names to help you track performance analytics later.
                </p>
            </div>
        </div>
    );
};

export default Step1Title;
